/**
 * Get Products for Distribution Use Case
 *
 * This use case handles fetching products available for distribution
 * following clean architecture principles.
 *
 * @module GetProductsForDistributionUseCase
 */

import {DistributionRepository} from '../repository/DistributionRepository';
import {DistributionProduct} from '../models/distribution.model';

export class GetProductsForDistributionUseCase {
  constructor (private distributionRepository: DistributionRepository) {}

  async execute (search?: string): Promise<DistributionProduct[]> {
    try {
      return await this.distributionRepository.getProductsForDistribution(search);
    } catch (error) {
      throw error;
    }
  }
}
